import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterText'
})
export class FilterTextPipe implements PipeTransform {

  transform(value: any, option: string, model :string): any {
    if (!value) return value;
    if(model==="") {
      return value;
    } else {
       return value.filter( (item : any)=> (item[option].toUpperCase().indexOf(model.toUpperCase()) > -1)); 
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/section/patient/pipe/filter-text.pipe.ts